import type { App } from 'vue';
import router from '@/router';
import routes from './routes';

export declare interface Metrics {
  install: (app: App) => void;
}

export function createMetrics() : Metrics {
  return {
    install: (app: App) => {
      routes.forEach(route => {
        router.addRoute('base', route);
      });
    },
  };
}